import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';

import { Spinner } from 'components';

import {
  ProcessWrapper,
  ProcessName,
  InfoWrapper,
  InfoText,
} from 'apps/processMonitor/styles';

@withNamespaces()
@observer
export class Process extends React.Component {
  render() {
    const { fileManager } = this.props;
    const { file, uploadStatusText } = fileManager;

    return (
      <ProcessWrapper>
        <ProcessName>{file.filename}</ProcessName>
        <InfoWrapper>
          <InfoText>{uploadStatusText}</InfoText>
          <Spinner size='small' />
        </InfoWrapper>
      </ProcessWrapper>
    );
  }
}

Process.propTypes = {
  fileManager: PropTypes.object,
};
